// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fa;
  font-size: 16px;
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Responsive font sizes for better readability */
@media (min-width: 768px) {
  body {
    font-size: 17px;
  }
  
  .h1, h1 { font-size: 2.5rem; }
  .h2, h2 { font-size: 2rem; }
  .h3, h3 { font-size: 1.75rem; }
  .h4, h4 { font-size: 1.5rem; }
  .h5, h5 { font-size: 1.25rem; }
  .h6, h6 { font-size: 1.1rem; }
  
  .btn {
    font-size: 1.1rem;
    padding: 0.5rem 1.25rem;
  }
  
  .form-control, .form-select {
    font-size: 1.1rem;
    padding: 0.5rem 0.75rem;
  }
}

@media (min-width: 1200px) {
  body {
    font-size: 18px;
  }
}

/* Global improvements */
.card {
  border: 1px solid rgba(0,0,0,.08);
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
}

.btn-primary {
  background-color: #4D64C1;
  border-color: #4D64C1;
}

.btn-primary:hover {
  background-color: #3a4f9e;
  border-color: #3a4f9e;
}

.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
}

/* Smooth transitions */
* {
  transition: color 0.15s ease-in-out,
              background-color 0.15s ease-in-out,
              border-color 0.15s ease-in-out,
              box-shadow 0.15s ease-in-out;
}

/* Primary buttons - for main actions */
.btn-primary,
button[type="submit"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link) {
  background-color: #4D64C1 !important;
  border-color: #4D64C1 !important;
  color: white !important;
  font-weight: 500;
  padding: 0.5rem 1.5rem;
  box-shadow: 0 2px 4px rgba(77, 100, 193, 0.2);
  transition: all 0.3s ease;
}

.btn-primary:hover,
button[type="submit"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link):hover {
  background-color: #3a4f9e !important;
  border-color: #3a4f9e !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(77, 100, 193, 0.3);
}

.btn-primary:active,
button[type="submit"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link):active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(77, 100, 193, 0.2);
}

/* Secondary buttons - for less important actions */
.btn-secondary,
.btn-outline-primary {
  background-color: white !important;
  border: 2px solid #4D64C1 !important;
  color: #4D64C1 !important;
  font-weight: 500;
  padding: calc(0.5rem - 2px) calc(1.5rem - 2px);
  transition: all 0.3s ease;
}

.btn-secondary:hover,
.btn-outline-primary:hover {
  background-color: #f8f9fc !important;
  border-color: #3a4f9e !important;
  color: #3a4f9e !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(77, 100, 193, 0.15);
}

.btn-secondary:active,
.btn-outline-primary:active {
  transform: translateY(0);
  box-shadow: inset 0 1px 3px rgba(77, 100, 193, 0.2);
}

/* Success buttons - for positive actions */
.btn-success {
  background-color: #4CAF50 !important;
  border-color: #4CAF50 !important;
  color: white !important;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-success:hover {
  background-color: #388E3C !important;
  border-color: #388E3C !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);
}

/* Link buttons - for tertiary actions */
.btn-link {
  color: #4D64C1 !important;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  padding: 0.25rem 0.5rem;
  transition: all 0.2s ease;
}

.btn-link:hover {
  color: #3a4f9e !important;
  text-decoration: none;
}

.btn-link:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #4D64C1;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.btn-link:hover:after {
  width: 100%;
}

/* Disabled state */
.btn:disabled,
.btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Button sizes */
.btn-sm {
  padding: 0.25rem 1rem;
  font-size: 0.875rem;
}

.btn-lg {
  padding: 0.75rem 2rem;
  font-size: 1.125rem;
}

/* Icon buttons */
.btn-icon {
  width: 40px;
  height: 40px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.btn-icon.btn-secondary {
  background-color: #f8f9fc !important;
  border: 1px solid #e9ecef !important;
  color: #4D64C1 !important;
}

.btn-icon.btn-secondary:hover {
  background-color: #4D64C1 !important;
  border-color: #4D64C1 !important;
  color: white !important;
}

/* Links */
a {
  color: #4D64C1;
}

a:hover {
  color: #3a4f9e;
}

/* Text color classes */
.text-primary {
  color: #4D64C1 !important;
}

/* Interactive card hover effects */
.card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,.08);
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0,0,0,.1);
  border-color: rgba(77, 100, 193, 0.2);
}

.card.card-clickable {
  cursor: pointer;
}

/* Form inputs with better focus states */
.form-control,
.form-select {
  border: 1px solid #ced4da;
  transition: all 0.2s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #4D64C1;
  box-shadow: 0 0 0 0.2rem rgba(77, 100, 193, 0.1);
}

/* Badge styles */
.badge-primary {
  background-color: #4D64C1 !important;
}

.badge-secondary {
  background-color: #f8f9fc !important;
  color: #4D64C1 !important;
  border: 1px solid #4D64C1;
}

/* Animated loading spinner */
.spinner-border {
  color: #4D64C1;
}

/* Table hover effects */
.table-hover tbody tr {
  transition: all 0.2s ease;
}

.table-hover tbody tr:hover {
  background-color: rgba(77, 100, 193, 0.05);
  transform: scale(1.01);
}

/* Navigation active states */
.nav-link {
  position: relative;
  transition: all 0.3s ease;
}

.nav-link.active {
  color: #4D64C1 !important;
}

/* Tooltips */
.tooltip-inner {
  background-color: #4D64C1;
}

.bs-tooltip-top .arrow::before {
  border-top-color: #4D64C1;
}

/* Dropdown improvements */
.dropdown-item {
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: rgba(77, 100, 193, 0.1);
  color: #4D64C1;
  padding-left: 1.75rem;
}

.dropdown-item.active {
  background-color: #4D64C1;
}

/* Alert styles */
.alert-primary {
  background-color: rgba(77, 100, 193, 0.1);
  border-color: #4D64C1;
  color: #2d3a78;
}

/* Progress bars */
.progress-bar {
  background-color: #4D64C1;
}

/* Custom checkbox and radio */
.form-check-input:checked {
  background-color: #4D64C1;
  border-color: #4D64C1;
}

.form-check-input:focus {
  border-color: #4D64C1;
  box-shadow: 0 0 0 0.25rem rgba(77, 100, 193, 0.25);
}

/* Switch style */
.form-switch .form-check-input:checked {
  background-color: #4D64C1;
}

/* Pagination */
.page-link {
  color: #4D64C1;
  transition: all 0.2s ease;
}

.page-link:hover {
  color: #3a4f9e;
  background-color: rgba(77, 100, 193, 0.1);
}

.page-item.active .page-link {
  background-color: #4D64C1;
  border-color: #4D64C1;
}

/* Modal improvements */
.modal-header {
  background-color: #f8f9fc;
  border-bottom: 2px solid #4D64C1;
}

.modal-title {
  color: #4D64C1;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;;EAEA,UAAU,iBAAiB,EAAE;EAC7B,UAAU,eAAe,EAAE;EAC3B,UAAU,kBAAkB,EAAE;EAC9B,UAAU,iBAAiB,EAAE;EAC7B,UAAU,kBAAkB,EAAE;EAC9B,UAAU,iBAAiB,EAAE;;EAE7B;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE;;;0CAGwC;AAC1C;;AAEA,uCAAuC;AACvC;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,mDAAmD;AACnD;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8f9fa;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Responsive font sizes for better readability */\n@media (min-width: 768px) {\n  body {\n    font-size: 17px;\n  }\n  \n  .h1, h1 { font-size: 2.5rem; }\n  .h2, h2 { font-size: 2rem; }\n  .h3, h3 { font-size: 1.75rem; }\n  .h4, h4 { font-size: 1.5rem; }\n  .h5, h5 { font-size: 1.25rem; }\n  .h6, h6 { font-size: 1.1rem; }\n  \n  .btn {\n    font-size: 1.1rem;\n    padding: 0.5rem 1.25rem;\n  }\n  \n  .form-control, .form-select {\n    font-size: 1.1rem;\n    padding: 0.5rem 0.75rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  body {\n    font-size: 18px;\n  }\n}\n\n/* Global improvements */\n.card {\n  border: 1px solid rgba(0,0,0,.08);\n  box-shadow: 0 1px 3px rgba(0,0,0,.05);\n}\n\n.btn-primary {\n  background-color: #4D64C1;\n  border-color: #4D64C1;\n}\n\n.btn-primary:hover {\n  background-color: #3a4f9e;\n  border-color: #3a4f9e;\n}\n\n.badge {\n  font-weight: 500;\n  padding: 0.35em 0.65em;\n}\n\n/* Smooth transitions */\n* {\n  transition: color 0.15s ease-in-out,\n              background-color 0.15s ease-in-out,\n              border-color 0.15s ease-in-out,\n              box-shadow 0.15s ease-in-out;\n}\n\n/* Primary buttons - for main actions */\n.btn-primary,\nbutton[type=\"submit\"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link) {\n  background-color: #4D64C1 !important;\n  border-color: #4D64C1 !important;\n  color: white !important;\n  font-weight: 500;\n  padding: 0.5rem 1.5rem;\n  box-shadow: 0 2px 4px rgba(77, 100, 193, 0.2);\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover,\nbutton[type=\"submit\"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link):hover {\n  background-color: #3a4f9e !important;\n  border-color: #3a4f9e !important;\n  color: white !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(77, 100, 193, 0.3);\n}\n\n.btn-primary:active,\nbutton[type=\"submit\"]:not(.btn-secondary):not(.btn-outline-primary):not(.btn-link):active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(77, 100, 193, 0.2);\n}\n\n/* Secondary buttons - for less important actions */\n.btn-secondary,\n.btn-outline-primary {\n  background-color: white !important;\n  border: 2px solid #4D64C1 !important;\n  color: #4D64C1 !important;\n  font-weight: 500;\n  padding: calc(0.5rem - 2px) calc(1.5rem - 2px);\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover,\n.btn-outline-primary:hover {\n  background-color: #f8f9fc !important;\n  border-color: #3a4f9e !important;\n  color: #3a4f9e !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(77, 100, 193, 0.15);\n}\n\n.btn-secondary:active,\n.btn-outline-primary:active {\n  transform: translateY(0);\n  box-shadow: inset 0 1px 3px rgba(77, 100, 193, 0.2);\n}\n\n/* Success buttons - for positive actions */\n.btn-success {\n  background-color: #4CAF50 !important;\n  border-color: #4CAF50 !important;\n  color: white !important;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.btn-success:hover {\n  background-color: #388E3C !important;\n  border-color: #388E3C !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);\n}\n\n/* Link buttons - for tertiary actions */\n.btn-link {\n  color: #4D64C1 !important;\n  text-decoration: none;\n  font-weight: 500;\n  position: relative;\n  padding: 0.25rem 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.btn-link:hover {\n  color: #3a4f9e !important;\n  text-decoration: none;\n}\n\n.btn-link:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 0;\n  height: 2px;\n  background-color: #4D64C1;\n  transition: all 0.3s ease;\n  transform: translateX(-50%);\n}\n\n.btn-link:hover:after {\n  width: 100%;\n}\n\n/* Disabled state */\n.btn:disabled,\n.btn.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Button sizes */\n.btn-sm {\n  padding: 0.25rem 1rem;\n  font-size: 0.875rem;\n}\n\n.btn-lg {\n  padding: 0.75rem 2rem;\n  font-size: 1.125rem;\n}\n\n/* Icon buttons */\n.btn-icon {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.btn-icon.btn-secondary {\n  background-color: #f8f9fc !important;\n  border: 1px solid #e9ecef !important;\n  color: #4D64C1 !important;\n}\n\n.btn-icon.btn-secondary:hover {\n  background-color: #4D64C1 !important;\n  border-color: #4D64C1 !important;\n  color: white !important;\n}\n\n/* Links */\na {\n  color: #4D64C1;\n}\n\na:hover {\n  color: #3a4f9e;\n}\n\n/* Text color classes */\n.text-primary {\n  color: #4D64C1 !important;\n}\n\n/* Interactive card hover effects */\n.card {\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0,0,0,.08);\n}\n\n.card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0,0,0,.1);\n  border-color: rgba(77, 100, 193, 0.2);\n}\n\n.card.card-clickable {\n  cursor: pointer;\n}\n\n/* Form inputs with better focus states */\n.form-control,\n.form-select {\n  border: 1px solid #ced4da;\n  transition: all 0.2s ease;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #4D64C1;\n  box-shadow: 0 0 0 0.2rem rgba(77, 100, 193, 0.1);\n}\n\n/* Badge styles */\n.badge-primary {\n  background-color: #4D64C1 !important;\n}\n\n.badge-secondary {\n  background-color: #f8f9fc !important;\n  color: #4D64C1 !important;\n  border: 1px solid #4D64C1;\n}\n\n/* Animated loading spinner */\n.spinner-border {\n  color: #4D64C1;\n}\n\n/* Table hover effects */\n.table-hover tbody tr {\n  transition: all 0.2s ease;\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(77, 100, 193, 0.05);\n  transform: scale(1.01);\n}\n\n/* Navigation active states */\n.nav-link {\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.nav-link.active {\n  color: #4D64C1 !important;\n}\n\n/* Tooltips */\n.tooltip-inner {\n  background-color: #4D64C1;\n}\n\n.bs-tooltip-top .arrow::before {\n  border-top-color: #4D64C1;\n}\n\n/* Dropdown improvements */\n.dropdown-item {\n  transition: all 0.2s ease;\n}\n\n.dropdown-item:hover {\n  background-color: rgba(77, 100, 193, 0.1);\n  color: #4D64C1;\n  padding-left: 1.75rem;\n}\n\n.dropdown-item.active {\n  background-color: #4D64C1;\n}\n\n/* Alert styles */\n.alert-primary {\n  background-color: rgba(77, 100, 193, 0.1);\n  border-color: #4D64C1;\n  color: #2d3a78;\n}\n\n/* Progress bars */\n.progress-bar {\n  background-color: #4D64C1;\n}\n\n/* Custom checkbox and radio */\n.form-check-input:checked {\n  background-color: #4D64C1;\n  border-color: #4D64C1;\n}\n\n.form-check-input:focus {\n  border-color: #4D64C1;\n  box-shadow: 0 0 0 0.25rem rgba(77, 100, 193, 0.25);\n}\n\n/* Switch style */\n.form-switch .form-check-input:checked {\n  background-color: #4D64C1;\n}\n\n/* Pagination */\n.page-link {\n  color: #4D64C1;\n  transition: all 0.2s ease;\n}\n\n.page-link:hover {\n  color: #3a4f9e;\n  background-color: rgba(77, 100, 193, 0.1);\n}\n\n.page-item.active .page-link {\n  background-color: #4D64C1;\n  border-color: #4D64C1;\n}\n\n/* Modal improvements */\n.modal-header {\n  background-color: #f8f9fc;\n  border-bottom: 2px solid #4D64C1;\n}\n\n.modal-title {\n  color: #4D64C1;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
